import { render, staticRenderFns } from "./cardForm.vue?vue&type=template&id=38cc41d7&scoped=true&"
import script from "./cardForm.vue?vue&type=script&lang=js&"
export * from "./cardForm.vue?vue&type=script&lang=js&"
import style0 from "./cardForm.vue?vue&type=style&index=0&id=38cc41d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc41d7",
  null
  
)

export default component.exports